<template>
  <a-modal :maskClosable="false" :visible="value" :title="id?$t('edit')+$t('page_andon')+$t('page_andon_call_type'):$t('create')+$t('page_andon')+$t('page_andon_call_type')" :width="600" @cancel="onClose">
    <a-form-model :model="form" :rules="rules" ref="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('page_system_coding_rules')" prop="codeRuleId" v-if="!id">
          <a-select v-model="form.codeRuleId"
          :placeholder="$t('please_select')"
          show-search
          optionFilterProp="children"
          allowClear
          @change="changeCodeRule"
          >
            <a-select-option :value="item.id" v-for="(item,index) in codeRuleList" :key="index">
              {{item.name}}
            </a-select-option>
          </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('page_andon')+$t('page_andon_call_type_code')" prop="code" :rules="{ required:!form.codeRuleId, message: '请输入', trigger: 'blur' }">
        <a-input :placeholder="$t('common_please_input')+$t('page_andon')+$t('page_andon_call_type_code')" :disabled="(!!form.codeRuleId || !!id)" v-model="form.code" />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_andon')+$t('page_andon_call_type')" prop="name">
        <a-input :placeholder="$t('common_please_input')+$t('page_andon')+$t('page_andon_call_type')" v-model="form.name" />
      </a-form-model-item>

      <!--处理人员-->
      <a-form-model-item :label="$t('page_andon_call_processing_personnel')">
        <a-select v-model="form.employeeId"
                  :placeholder="$t('please_select')"
                  show-search
                  optionFilterProp="children"
                  allowClear
                  mode="multiple"
                  @change="changeEmployee"
        >
          <a-select-option :value="item.id" v-for="(item,index) in employeeList" :key="index">
            {{item.name}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <!--类型状态颜色-->
      <a-form-model-item :label="$t('page_andon_call_type_status_color')">
       <div class="color-form"><colorPicker v-model="form.color"/></div>
      </a-form-model-item>

      <a-form-model-item :label="$t('remark')">
        <a-textarea
          :placeholder="$t('common_please_input')+$t('remark')"
          :auto-size="{ minRows: 2, maxRows: 6 }"
          v-model="form.remark"
        />
      </a-form-model-item>
    </a-form-model>
    <div slot="footer">
       <a-button @click="onClose" type="default">
        {{$t('cancel')}}
      </a-button>
      <a-button @click="onReset" type="danger">
        {{$t('common_reset')}}
      </a-button>
       <a-button :loading="submitLoading" @click="onSubmit" type="primary">
        {{$t('save')}}
      </a-button>
     </div>
  </a-modal>
</template>

<script>
import { cloneDeep } from 'lodash'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import {AndonTypeServiceProxy} from '@/service-proxies/app-v2/andon.service-proxies'
import { EmployeeServiceProxy } from "@/service-proxies/app-v2/employee.service-proxies"
const andonTypeServiceProxy = new AndonTypeServiceProxy();
const crsp = new CodeRuleServiceProxy()
const esp = new EmployeeServiceProxy()

export default {
  props:{
    value:{
      type:Boolean,
      default:false
    },
    id:{
    }
  },
  watch:{
    value (newVal, oldVal) {
      if (!newVal) {
        this.$refs.form.resetFields()
        this.form = { color: '#000000', employeeId: [] }
      } else {
        this.getCodeRules()
        this.getDetail()
      }
    }
  },
  created() {
    this.getEmployeeList()
  },
  methods:{
    async getEmployeeList () {
      let params = { statusList: [1] }
      this.employeeList = await esp.getEmployeeList(params)
    },
    async getCodeRules(){
      const res = await crsp.list('AndonTypeObject')
      this.codeRuleList = res;
    },
    getDetail(){
      if(!this.id) return;
      andonTypeServiceProxy.getAndonType(this.id).then(res => {
        this.form = res;
        this.form.employeeId = res.employeeIds ? res.employeeIds.split(',') : []
        this.detail = cloneDeep(this.form)
      })
    },
    onClose(){
      this.$emit('close',false);
    },
    changeCodeRule(val){
       this.$nextTick(() => {
         if(val){
           this.$refs.form.validateField('code');
         }
       })
    },
    changeEmployee (val) {
      let temp = cloneDeep(this.form)
      temp.employeeId = val
      this.form = temp
    },
    // 重置
    onReset(){
      this.$refs.form.clearValidate();
      if (this.id) {
        this.form = {
          id: this.id,
          code: this.detail.code,
          codeRuleId: this.detail.codeRuleId,
          name: this.detail.name,
          remark: this.detail.remark,
          color: this.detail.color,
          employeeId: this.detail.employeeId
        }
      } else {
        this.$refs.form.resetFields()
        this.form = { color: '#000000', employeeId: [] }
      }
    },
    getEmployeeRecord(data) {
      let temp = []
      this.employeeList.map(item=>{
        if(data.includes(item.id)) {
          temp.push({
            employeeCode: item.code,
            employeeId: item.id,
            employeeName: item.name,
          })
        }
      })
      return temp
    },
    // 保存
    onSubmit(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.id){
            this.handleUpdate();
          }else{
            this.handleAdd();
          }
        }
      });
    },
    handleAdd(){
      this.submitLoading = true;
      let newAndonTypeEmployeeDTOS = this.getEmployeeRecord(this.form.employeeId)
      Object.assign(this.form, { newAndonTypeEmployeeDTOS })
      andonTypeServiceProxy.saveAndonType(this.form).then(res => {
        this.submitLoading = false;
        this.$message.success(this.$t('new_create_success'))
        this.$emit('submit')
      }).catch(() => {
        this.submitLoading = false;
      })
    },
    handleUpdate(){
      this.submitLoading = true;
      let data = {
        codeRuleId:this.form.codeRuleId,
        code:this.form.code,
        id:this.form.id,
        name:this.form.name,
        remark:this.form.remark,
        color:this.form.color,
      }
      let newAndonTypeEmployeeDTOS = this.getEmployeeRecord(this.form.employeeId)
      Object.assign(data, { newAndonTypeEmployeeDTOS })
      andonTypeServiceProxy.updateAndonType(data).then(res => {
        this.submitLoading = false;
        this.$message.success(this.$t('update_success'))
        this.$emit('submit')
      }).catch(() => {
        this.submitLoading = false;
      })
    }
  },
  data(){
    return {
      labelCol: {span: 6},
      wrapperCol: {span: 16},
      form:{color: '#000000', employeeId: []},
      codeRuleList:[],
      detail: {},
      rules:{
        // type: [
        //   { required: true, message: '请选择', trigger: 'change' },
        // ],
        // code: [
        //   { required: true, message: '请输入', trigger: 'blur' },
        // ],
        name: [
          { required: true, message: this.$t('common_please_input'), trigger: 'blur' },
        ]
      },
      submitLoading:false,
      employeeList: []
    }
  }
}
</script>

<style lang="less" scoped>
.color-form {
  height: 32px;
  width: 100%;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  line-height: 35px;
  padding-left: 11px;
}
</style>
